import { createSelector } from 'reselect';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getZeroState } from '../../zero-state/selectors/getZeroState';
import { isFormsSetup } from '../../zero-state/operators/getters';
export const getIsFormsSetup = createSelector([getCurrentInboxId, getZeroState], (currentInboxId, zeroState) => {
  return isFormsSetup(currentInboxId, zeroState);
});